import React from "react";
import { useParams } from "react-router-dom";
import useSWR from "swr";
import Loading from "../common/Loading";
import Project from "./Project";
import { fetcher } from "../utils/fetch";

export default function ProjectPage() {
    const { id } = useParams();
    const { data, error } = useSWR(`/api/projects/${ id }`, fetcher);

    return (
        <Loading loading={ !data || error }>
            <Project project={ data } />
        </Loading>
    )
}
